import React from "react";
import { useCustomQuery } from "utilities/hookutils";
import DocumentReminderPanel from "./DocumentReminderPanel";
import moment from "moment";
import { Reminder } from "./models";
import InvoiceReminderRowCard from "./InvoiceReminderCard";

interface Props {
  invoice: server.dto.InvoiceV2;
  initialReminders: server.dto.InvoiceReminder[]
}

export const getInvoiceRemindersQueryKey = (invoiceId: number) => ["invoice-reminders", invoiceId];

export const InvoiceReminderApp = (props: Props) => {
  const remindersQuery = useCustomQuery({
    queryKey: getInvoiceRemindersQueryKey(props.invoice.invoiceId),
    queryFn: () => window.CoreApi.InvoiceV2.ListReminders(props.invoice.invoiceId).then(r => r.data.data),
    initialData: props.initialReminders,
  });

  const deleteAllReminders = () => window.CoreApi.InvoiceV2.DeleteAllReminders(props.invoice.invoiceId);

  const addReminder = (days: number) => window.CoreApi.InvoiceV2.AddReminder({
    invoiceId: props.invoice.invoiceId,
    daysAfterDueDate: days,
  });

  const updateReminder = (days: number, reminderNr: number) => window.CoreApi.InvoiceV2.UpdateReminder({
    invoiceId: props.invoice.invoiceId,
    daysAfterDueDate: days,
    type: ("reminder" + reminderNr) as server.dto.DocumentReminderTypes,
  });

  const clearLastReminder = () => window.CoreApi.InvoiceV2.DeleteLastReminder(props.invoice.invoiceId)


  const dueMoment = (props.invoice.lifeCycle === "draft" || props.invoice.lifeCycle === "review")
    ? moment.utc().startOf("day").add(props.invoice.dueInDays, "days")
    : moment.utc(props.invoice.invoiceDate).add(props.invoice.dueInDays, "days");
  const canClearAll = props.invoice.lifeCycle !== "completed" && remindersQuery.data.some(reminder => !reminder.isSent);
  const canDisplayAddNewReminder = props.invoice.lifeCycle !== "completed" && remindersQuery.data.length < serverReference.constants.invoice.maxReminders

  const reminders = remindersQuery.data.map<Reminder>(reminder => ({
    days: reminder.daysAfterDueDate,
    reminderNr: reminder.type.number,
    isSent: reminder.isSent,
  }));


  return <DocumentReminderPanel
    maxDaysAfterSendDate={serverReference.constants.invoice.maxReminderInterval}
    documentSendMoment={dueMoment}
    reminders={reminders}
    clearLastReminder={clearLastReminder}
    renderCard={(reminder, setEditingReminder, clearLastReminder, isLast) => <InvoiceReminderRowCard
      key={reminder.reminderNr}
      value={reminder}
      dueMoment={dueMoment}
      isLast={isLast}
      documentLifeCycle={props.invoice.lifeCycle}
      onClearLastReminder={clearLastReminder}
      onReminderEdit={setEditingReminder}
    />}

    deleteAllReminders={deleteAllReminders}
    addReminder={addReminder}
    updateReminder={updateReminder}
    refetch={remindersQuery.refetch}

    canClearAll={canClearAll}
    canDisplayAddNewReminder={canDisplayAddNewReminder}

  />
}